import { HealthTeam } from "@/@types/esus/HealthTeam";
import { HealthUnit } from "@/@types/esus/HealthUnit";
import { PaginationFilter } from "@/@types/generics/genericals";
import { Paginated } from "@/@types/generics/paginated";
import { esusApi } from "@/services/api";

export type DetailedCitizenScoresIndicatorC3Params = PaginationFilter & {
	uf: string;
	ibgeCode: string;
	quarter: string;
	year: number;
	month: number;
	search: string;
	isEvaluated?: boolean;
	ine?: string;
	export?: boolean;
};

export class DetailedCitizenScoresIndicatorC3Data {
	id: number = 0;
	cpf?: string;
	cns?: string;
	birthdate: string = "";
	fullName: string = "";
	healthUnitId: number = 0;
	healthTeamId: number = 0;
	healthUnit?: HealthUnit;
	healthTeam?: HealthTeam;
	area?: string;
	motherName?: string;
	gender?: number;
	street?: string;
	houseNumber?: string;
	neighborhood?: string;
	phone?: string;
	dumDate: string = "";
	dppDate: string = "";
	gestationalAge?: number;
	inactivePregnancyDate?: string;
	pregnancyStatus: "pregnant" | "puerperal" | "finished" = "pregnant";
	firstAttendanceStatus: "finished" | "pending" | "lost" = "lost";
	sevenPregnancyAttendancesStatus: "finished" | "pending" | "lost" = "lost";
	sevenBloodPressureMeasurementsStatus: "finished" | "pending" | "lost" = "lost";
	sevenWeightAndHeightMetricsRegistersStatus: "finished" | "pending" | "lost" = "lost";
	threeAcsHomeVisitsStatus: "finished" | "pending" | "lost" = "lost";
	vaccinationStatus: "finished" | "pending" | "lost" = "lost";
	firstTrimesterProceduresStatus: "finished" | "pending" | "lost" = "lost";
	thirdTrimesterProceduresStatus: "finished" | "pending" | "lost" = "lost";
	puerperalAttendanceStatus: "finished" | "pending" | "lost" = "lost";
	puerperalAcsHomeVisitStatus: "finished" | "pending" | "lost" = "lost";
	dentalAttendancesStatus: "finished" | "pending" | "lost" = "lost";
	score: number = 0;
}

export async function getDetailedCitizensScoresIndicatorC3({
	uf,
	ibgeCode,
	...params
}: DetailedCitizenScoresIndicatorC3Params) {
	const response = await esusApi.get<Paginated<DetailedCitizenScoresIndicatorC3Data>>(
		`/uf/${uf}/city/${ibgeCode}/indicator/esf/c3/detailed-citizens-scores`,
		params
	);
	return response.data ?? new Paginated<DetailedCitizenScoresIndicatorC3Data>();
}
